import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const CountryRegistrations = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const defaultOpenAddItemPopup = urlParams.get("defaultOpenAddItemPopup") ?? null;

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});


    // Receives the ExpiryDate (config.rowStyleProcessorColumn)
    const rowStyleProcessor = (value) => {

        if (!value) return "";

        const date = new Date(value);
        const today = new Date();

        // Remove time component for date-only comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        if (date < today) {
            return "datatable-row-red";
        }

        const daysUntilDue = Math.ceil(
            (date - today) / (1000 * 60 * 60 * 24)
        );

        if (daysUntilDue <= 30) {
            return "datatable-row-yellow";
        }

        return "";
    };


    let config = {};

    config.dataUrl = "/umbraco/api/RIMSRegistrations/Registrations";
    config.getSingleItemUrl = "/umbraco/api/RIMSRegistrations/Registration";
    config.pageTitle = "Country Registrations";
    config.singleItemTitle = "Country Registration";
    config.entityType = "countryregistrations";
    config.entityTypeId = 9; // country registrations
    config.pageIcon = "fas fa-clipboard-list";
    config.breadcrumbs = [{ "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" }, { "Name": "All Registrations" }]
    config.dataStructure = [];
    config.exportUrl = "/umbraco/api/RIMSRegistrations/RegistrationsExport/?registrationIds="; 
    config.deleteUrl = "/umbraco/api/RIMSRegistrations/BulkRegistrations/?registrationIds=";
    //config.enableTags = true;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.enableCustomFields = true;
    config.showExportButton = true;
    config.showDeleteButton = true;
    config.productStandardsListItemUrl = window.productStandardsListItemUrl;
    config.productRegulatoryDocumentsListItemUrl = window.productRegulatoryDocumentsListItemUrl;
    config.productReferenceManagerListItemUrl = window.productReferenceManagerListItemUrl;
    config.preLoadItemUrlParamName = "registrationId";
    //config.udisUrl = "/umbraco/api/RIMSRegistrations/ProductsExport/?productIds=";
    config.excelExportFileName = "MedBoardRegistrationsExport";
    config.hideSelectAllCheckbox = true;
    config.defaultOpenAddItemPopup = defaultOpenAddItemPopup ? defaultOpenAddItemPopup : false;
    //config.defaultOrderByField = "ProductSKUCode";
    config.preLoadItemId = window.preloadRegistrationId;
    config.reachedAllowance = reachedAllowanceRegistrations;
    config.hideSearchBar = true;
    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/RIMSRegistrations/RegistrationsCount/";
    config.rowStyleProcessor = rowStyleProcessor;
    config.rowStyleProcessorColumn = "ExpiryDate";
    config.showTaskCount= true;

    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = (isRefresh = null) => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                        hasFilter: column.HasFilter
                        //hasFilter: true // FOR TESTING
                    });
                });


                // isRefresh probably came from the columns configuration request to refresh the table, so clean some variables
                if (isRefresh) {
                    config.defaultOpenAddItemPopup = false;
                }

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }



    

    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure}
                            ItemDetailsPane={ItemDetailsPane}
                            AddItemPopup={AddItemPopup}
                            ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);

};






export default CountryRegistrations;